import { Pipe, PipeTransform } from '@angular/core';
import { IncidentTypeEnum } from '@shared/core/enums/incidents.enum';

@Pipe({ name: 'incidentType' })
export class IncidentTypePipe implements PipeTransform {
  transform(value: IncidentTypeEnum): string {
    switch (value) {
      case IncidentTypeEnum.SIGNATURE_SUBJECT_TO_CHANGE:
        return 'incidents.incident_type.signature_with_reservation';
      case IncidentTypeEnum.PROBLEMS_WITH_PICKUP:
        return 'incidents.incident_type.problems_with_pickup';
      case IncidentTypeEnum.PROBLEMS_WITH_DELIVERY:
        return 'incidents.incident_type.problems_with_delivery';
      case IncidentTypeEnum.LOSS_OF_SHIPMENT:
        return 'incidents.incident_type.loss_of_shipment';
    }
  }
}
